import { render, staticRenderFns } from "./AddUserDialog.vue?vue&type=template&id=5f4d37eb&scoped=true"
import script from "./AddUserDialog.vue?vue&type=script&lang=js"
export * from "./AddUserDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4d37eb",
  null
  
)

export default component.exports